export const counterWidgetLayoutType = {
    standard: "standard",
    wide: "wide",
};

export const counterWidgetLayoutConfig = {
    [counterWidgetLayoutType.standard]: {
        singleRowUpTo: 2,
        multiRowUpTo: 6,
        splitRowCount: 2,
        maxRowCount: 3,
    },
    [counterWidgetLayoutType.wide]: {
        singleRowUpTo: 3,
        multiRowUpTo: 9,
        splitRowCount: 3,
        maxRowCount: 3,
    },
};
